import { requestPlatform } from '@/plugins/axios'

// {machine}  新增机台
export function onSubmit(data) {
   return requestPlatform({
        url: '/machine/save',
        method: 'POST',
        data: data
      })
}
